<template>
  <div class="tour-admin-notification-preferences-container">
    <h4>Notification preferences</h4>
    <ul>
      <li>
        <div>
          <p><b>Registrations</b></p>
          <p class="description">
            When enabled, you will receive notifications for registrations.
          </p>
        </div>
        <TjingToggle v-model="registrationNotificationEnabled" />
      </li>
      <li>
        <div>
          <p><b>Cancellations</b></p>
          <p class="description">
            When enabled, you will receive notifications for cancellations.
          </p>
        </div>
        <TjingToggle v-model="cancellationNotificationEnabled" />
      </li>
      <li>
        <div>
          <p><b>DNFs</b></p>
          <p class="description">
            When enabled, you will receive notifications when a player DNF.
          </p>
        </div>
        <TjingToggle v-model="dnfNotificationEnabled" />
      </li>
      <li>
        <div>
          <p><b>Pace of Play</b></p>
          <p class="description">
            When enabled, you will receive notifications when groups are waiting
            or holes are playing slower than usual.
          </p>
        </div>
        <TjingToggle v-model="backupWarningsEnabled" />
      </li>
    </ul>
    <div class="action-buttons">
      <TjingButton title="Cancel" @click="cancel()" />
      <TjingButton
        title="Save"
        @click="save()"
        variant="solid"
        color="midnight"
      />
    </div>
  </div>
</template>

<script>
import TjingToggle from '@/components/UIElements/TjingToggle.vue'
import TjingButton from '@/components/UIElements/TjingButton.vue'
export default {
  name: 'TourAdminNotificationPreferences',
  components: {
    TjingToggle,
    TjingButton,
  },
  props: {
    admin: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      registrationNotificationEnabled: false,
      cancellationNotificationEnabled: false,
      dnfNotificationEnabled: false,
      backupWarningsEnabled: false,
    }
  },
  computed: {},
  methods: {
    cancel() {
      this.$emit('close')
    },
    save() {
      this.updateAdministrator()
    },
    async updateAdministrator() {
      try {
        const transferToken = await this.$axios({
          headers: {
            Authorization: this.$store.state.user.sessionInfo.token,
          },
          data: {
            query: `
              mutation {
                UpdateAdministrator(userId:"${this.admin.userId}", tourId:"${this.admin.tourId}", input:{
                  registrationNotificationEnabled: ${this.registrationNotificationEnabled},
                  cancellationNotificationEnabled: ${this.cancellationNotificationEnabled},
                  dnfNotificationEnabled: ${this.dnfNotificationEnabled},
                  backupWarningsEnabled: ${this.backupWarningsEnabled},
                }){
                  userId
                }
              }
            `,
          },
        })

        if (transferToken.data.errors) {
          throw transferToken.data.errors[0]
        }

        this.$store.dispatch('showMessage', {
          show: true,
          message: 'Preferences saved',
          type: 'success',
        })
      } catch (e) {
        this.$store.dispatch('showMessage', {
          show: true,
          message: e.message || 'Error',
          type: 'error',
        })
      } finally {
        this.$emit('update')
      }
    },
  },
  mounted() {
    this.registrationNotificationEnabled =
      this.admin.registrationNotificationEnabled
    this.cancellationNotificationEnabled =
      this.admin.cancellationNotificationEnabled
    this.dnfNotificationEnabled = this.admin.dnfNotificationEnabled
    this.backupWarningsEnabled = this.admin.backupWarningsEnabled
    this.notifyTdEnabled = this.admin.notifyTdEnabled
  },
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';

.tour-admin-notification-preferences-container {
  max-width: 520px;
  padding: 32px;
  ul {
    margin-top: 2rem;
    display: block;
  }
}
.action-buttons {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid $fog;
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  border-top: 1px solid $fog;
  gap: 1rem;

  p {
    font-size: 1.125rem;
  }
  &:first-child {
    border-top: none;
    padding-top: 0;
  }
}
.description {
  margin-top: 0.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
  color: $strom;
}

h4 {
  margin-bottom: 0.5rem;
}
@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 992px) {
}
</style>
